var _path, _path2, _rect, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _rect9, _path4, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _g2, _rect18, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoTemplates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 681,
    height: 441,
    viewBox: "0 0 681 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M187.469 106.969C247.797 74.7351 311.047 69.5776 363.984 57.9732C433.594 42.5867 457.399 0.381116 538.438 4.24924C616.211 7.94545 624.805 83.9326 637.867 148.487C649.383 204.962 647.32 280.004 613.289 309.144C582.953 335.103 465.391 324.014 398.789 321.436C334.336 318.857 245.047 333.126 219.781 318.427C182.141 296.594 163.922 236.079 161.43 201.524C158.594 162.327 158.68 122.356 187.469 106.969Z",
    fill: "url(#paint0_linear)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M100.993 224.544C150.715 189.689 205.905 178.384 251.318 162.499C311.02 141.5 327.488 101.76 399.32 96.5082C468.256 91.4536 483.951 157.502 502.362 212.997C518.546 261.537 524.749 327.891 497.871 357.208C473.911 383.328 369.12 386.121 310.149 390.966C253.071 395.582 175.907 417.7 152.069 407.446C116.564 392.227 94.0403 340.843 88.1509 310.657C81.4624 276.416 77.2663 241.181 100.993 224.544Z",
    fill: "url(#paint1_linear)",
    fillOpacity: 0.3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.987061,
    width: 360,
    height: 226,
    rx: 6,
    fill: "#E7EEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.98706C0 3.67335 2.68629 0.987061 6 0.987061H354C357.314 0.987061 360 3.67335 360 6.98706V26.9871H0V6.98706Z",
    fill: "#BDD0FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 317,
    y: 9.98706,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#E7EEFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 276,
    y: 9.98706,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#E7EEFE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 235,
    y: 9.98706,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#E7EEFE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.98706,
    width: 56,
    height: 14,
    rx: 7,
    fill: "#E7EEFE"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 116.987,
    width: 171,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 102.987,
    width: 171,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 76.9871,
    width: 79,
    height: 13,
    rx: 6.5,
    fill: "#BDD0FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 67.9871,
    width: 360,
    height: 226,
    rx: 6,
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 73.9871C300 70.6734 302.686 67.9871 306 67.9871H654C657.314 67.9871 660 70.6734 660 73.9871V93.9871H300V73.9871Z",
    fill: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617,
    y: 76.9871,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576,
    y: 76.9871,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 76.9871,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 73.9871,
    width: 56,
    height: 14,
    rx: 7,
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 207.987,
    width: 171,
    height: 7,
    rx: 3.5,
    fill: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394,
    y: 193.987,
    width: 171,
    height: 7,
    rx: 3.5,
    fill: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 143.987,
    width: 79,
    height: 13,
    rx: 6.5,
    fill: "#BDD0FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437,
    y: 229.987,
    width: 85,
    height: 20,
    rx: 2,
    fill: "#E7EEFE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 479.5,
    cy: 150.487,
    r: 30.5,
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.87 151.182L472.18 161.247L472.18 141.117L489.87 151.182Z",
    fill: "white"
  })))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 214.987,
    width: 360,
    height: 226,
    rx: 6,
    fill: "#E7EEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136 220.987C136 217.673 138.686 214.987 142 214.987H490C493.314 214.987 496 217.673 496 220.987V240.987H136V220.987Z",
    fill: "#91B3FA"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 407,
    y: 223.987,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 223.987,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 223.987,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 223.987,
    width: 32,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 221.987,
    width: 56,
    height: 12,
    rx: 6,
    fill: "#BDD0FB"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 339.987,
    width: 203,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 185,
    y: 325.987,
    width: 263,
    height: 7,
    rx: 3.5,
    fill: "#BDD0FB"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 231,
    y: 299.987,
    width: 171,
    height: 13,
    rx: 6.5,
    fill: "#BDD0FB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 363.987,
    width: 85,
    height: 20,
    rx: 2,
    fill: "#1DA2F8"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 136.987,
    width: 85,
    height: 20,
    fill: "url(#paint3_linear)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.2 281.1C184.9 274.1 179 268.6 171.9 268.9C167.8 269.1 164.1 271.2 162 274.4C160.1 270.2 156.1 267 151.2 266.3C146.4 265.7 141.9 267.6 139 271C137 267.5 133.4 264.9 129.1 264.1C121.5 262.9 114.2 268.1 113 275.8C112.8 277.1 112.8 278.4 112.9 279.6C111.1 278.4 108.9 277.9 106.7 278.3C102.2 279.2 99.3 283.5 100.2 288C101.1 292.5 105.4 295.4 109.9 294.5L172 294.4C172.3 294.4 172.7 294.4 173 294.4C180 294.1 185.5 288.1 185.2 281.1Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M535.2 370.1C534.9 363.1 529 357.6 521.9 357.9C517.8 358.1 514.1 360.2 512 363.4C510.1 359.2 506.1 356 501.2 355.3C496.4 354.7 491.9 356.6 489 360C487 356.5 483.4 353.9 479.1 353.1C471.5 351.9 464.2 357.1 463 364.8C462.8 366.1 462.8 367.4 462.9 368.6C461.1 367.4 458.9 366.9 456.7 367.3C452.2 368.2 449.3 372.5 450.2 377C451.1 381.5 455.4 384.4 459.9 383.5L522 383.4C522.3 383.4 522.7 383.4 523 383.4C530 383.1 535.5 377.1 535.2 370.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 271,
    y: 46.9871,
    width: 410,
    height: 276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.17474 0 0 0 0 0.304047 0 0 0 0 0.7625 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 430,
    y: 110.987,
    width: 89,
    height: 89,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0928125 0 0 0 0 0.290756 0 0 0 0 0.675 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 256,
    y: 355.987,
    width: 111,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.107135 0 0 0 0 0.254982 0 0 0 0 0.779167 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 84,
    y: 256,
    width: 109.2,
    height: 54.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.395312 0 0 0 0 0.529719 0 0 0 0 0.6875 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 434,
    y: 345,
    width: 109.2,
    height: 54.7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.395312 0 0 0 0 0.529719 0 0 0 0 0.6875 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 160.227,
    y1: 164.987,
    x2: 644.185,
    y2: 164.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 83.1857,
    y1: 278.586,
    x2: 509.693,
    y2: 226.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5DEF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4EAF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 449.044,
    y1: 150.472,
    x2: 510.001,
    y2: 150.472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.0608,
    y1: 146.982,
    x2: 115.001,
    y2: 146.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.2,
    height: 30.7,
    fill: "white",
    transform: "translate(100 264)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.2,
    height: 30.7,
    fill: "white",
    transform: "translate(450 353)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTemplates);
export default __webpack_public_path__ + "static/media/info-templates.2e2caeb2.svg";
export { ForwardRef as ReactComponent };